import * as L from 'leaflet';
export class Location {
    id: string;
    latLng: L.LatLng;
    description: string;
}


// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/lib/maps/location.ts